// Permit Fees JavaScript - Loaded only for permit edit/new pages
document.addEventListener('turbolinks:load', function() {
  initializePermitFees();
});

function initializePermitFees() {
  // Initialize all existing permit price cards
  initializeAllPriceCards();

  // Setup the "Add Fee Structure" button to initialize new cards
  const addButton = document.querySelector('[data-association-insertion-node="#permit-prices-container"]');
  if (addButton) {
    addButton.addEventListener('click', function() {
      // Use setTimeout to wait for the new fields to be added to the DOM
      setTimeout(function() {
        initializeAllPriceCards();
      }, 100);
    });
  }
}

function initializeAllPriceCards() {
  const allPriceCards = document.querySelectorAll('.permits-price-card');

  allPriceCards.forEach((priceCard, index) => {
    // Skip if already initialized
    if (priceCard.hasAttribute('data-initialized')) {
      return;
    }

    priceCard.setAttribute('data-initialized', 'true');
    initializePriceCard(priceCard);
  });
}

function initializePriceCard(priceCard) {
  const priceTypeSelect = priceCard.querySelector('.price-type-select');
  const basedOnSelect = priceCard.querySelector('.based-on-select');
  const basedOnContainer = priceCard.querySelector('.based-on-container');
  const fixedAmountContainer = priceCard.querySelector('.fixed-amount-container');
  const percentageAmountContainer = priceCard.querySelector('.percentage-amount-container');
  const rangeContainer = priceCard.querySelector('.range-container');
  const lineItemContainer = priceCard.querySelector('.line-item-container');
  const perContainer = priceCard.querySelector('.per-container');

  if (!priceTypeSelect) return;

  // Function to toggle containers based on price type
  function toggleContainers() {
    const selectedValue = priceTypeSelect.value;

    if (selectedValue === 'fixed') {
      // Show fixed amount container, hide other containers
      if (fixedAmountContainer) fixedAmountContainer.style.display = 'block';
      if (percentageAmountContainer) percentageAmountContainer.style.display = 'none';
      if (rangeContainer) rangeContainer.style.display = 'none';
      if (lineItemContainer) lineItemContainer.style.display = 'none';
      if (perContainer) perContainer.style.display = 'none';

      // Show based_on container
      if (basedOnContainer) basedOnContainer.style.display = 'block';

      // Set the based_on field to optional and enable it
      if (basedOnSelect) {
        basedOnSelect.disabled = false;
        basedOnSelect.classList.remove('requiredField');
        updateBasedOnOptions(basedOnSelect, true); // true for optional
      }

      // Set required fields
      setRequiredFields(fixedAmountContainer, true);
      setRequiredFields(percentageAmountContainer, false);
      setRequiredFields(rangeContainer, false);
      setRequiredFields(lineItemContainer, false);
      setRequiredFields(perContainer, false);

    } else if (selectedValue === 'percentage') {
      // Show percentage amount container, hide other containers
      if (fixedAmountContainer) fixedAmountContainer.style.display = 'none';
      if (percentageAmountContainer) percentageAmountContainer.style.display = 'block';
      if (rangeContainer) rangeContainer.style.display = 'none';
      if (lineItemContainer) lineItemContainer.style.display = 'none';
      if (perContainer) perContainer.style.display = 'none';

      // Show based_on container
      if (basedOnContainer) basedOnContainer.style.display = 'block';

      // Set the based_on field to valuation and disable it
      if (basedOnSelect) {
        basedOnSelect.value = 'valuation';
        basedOnSelect.disabled = true;
        basedOnSelect.classList.add('requiredField');
        updateBasedOnOptions(basedOnSelect, false); // false for required
        // Update valuation symbols since we set it to valuation
        updateValuationSymbols(basedOnSelect, priceCard);
      }

      // Set required fields
      setRequiredFields(fixedAmountContainer, false);
      setRequiredFields(percentageAmountContainer, true);
      setRequiredFields(rangeContainer, false);
      setRequiredFields(lineItemContainer, false);
      setRequiredFields(perContainer, false);

    } else if (selectedValue === 'range') {
      // Show range container, hide other containers
      if (fixedAmountContainer) fixedAmountContainer.style.display = 'none';
      if (percentageAmountContainer) percentageAmountContainer.style.display = 'none';
      if (rangeContainer) rangeContainer.style.display = 'block';
      if (lineItemContainer) lineItemContainer.style.display = 'none';
      if (perContainer) perContainer.style.display = 'none';

      // Show based_on container
      if (basedOnContainer) basedOnContainer.style.display = 'block';

      // Set the based_on field to required and enable it
      if (basedOnSelect) {
        basedOnSelect.disabled = false;
        basedOnSelect.classList.add('requiredField');
        updateBasedOnOptions(basedOnSelect, false); // false for required
      }

      // Set required fields
      setRequiredFields(fixedAmountContainer, false);
      setRequiredFields(percentageAmountContainer, false);
      setRequiredFields(rangeContainer, true);
      setRequiredFields(lineItemContainer, false);
      setRequiredFields(perContainer, false);

      // Add default price range if none exists
      addDefaultPriceRange(priceCard);

    } else if (selectedValue === 'line_item') {
      // Show line item container, hide other containers
      if (fixedAmountContainer) fixedAmountContainer.style.display = 'none';
      if (percentageAmountContainer) percentageAmountContainer.style.display = 'none';
      if (rangeContainer) rangeContainer.style.display = 'none';
      if (lineItemContainer) lineItemContainer.style.display = 'block';
      if (perContainer) perContainer.style.display = 'none';

      // Hide based_on container for line items
      if (basedOnContainer) basedOnContainer.style.display = 'none';

      // Remove required from based_on field and enable it
      if (basedOnSelect) {
        basedOnSelect.disabled = false;
        basedOnSelect.classList.remove('requiredField');
      }

      // Set required fields
      setRequiredFields(fixedAmountContainer, false);
      setRequiredFields(percentageAmountContainer, false);
      setRequiredFields(rangeContainer, false);
      setRequiredFields(lineItemContainer, true);
      setRequiredFields(perContainer, false);

      // Initialize line items handler to ensure unique IDs
      handlePermitPriceLineItems(priceCard);
      addDefaultLineItem(priceCard);

    } else if (selectedValue === 'per') {
      if (fixedAmountContainer) fixedAmountContainer.style.display = 'none';
      if (percentageAmountContainer) percentageAmountContainer.style.display = 'none';
      if (rangeContainer) rangeContainer.style.display = 'none';
      if (lineItemContainer) lineItemContainer.style.display = 'none';
      if (perContainer) perContainer.style.display = 'block';

      // based_on not used for per type
      if (basedOnContainer) basedOnContainer.style.display = 'none';

      if (basedOnSelect) {
        basedOnSelect.disabled = false;
        basedOnSelect.classList.remove('requiredField');
      }

      setRequiredFields(fixedAmountContainer, false);
      setRequiredFields(percentageAmountContainer, false);
      setRequiredFields(rangeContainer, false);
      setRequiredFields(lineItemContainer, false);
      setRequiredFields(perContainer, true);

    } else {
      // No selection - hide all containers
      if (fixedAmountContainer) fixedAmountContainer.style.display = 'none';
      if (percentageAmountContainer) percentageAmountContainer.style.display = 'none';
      if (rangeContainer) rangeContainer.style.display = 'none';
      if (lineItemContainer) lineItemContainer.style.display = 'none';
      if (perContainer) perContainer.style.display = 'none';

      // Enable based_on field and remove required
      if (basedOnSelect) {
        basedOnSelect.disabled = false;
        basedOnSelect.classList.remove('requiredField');
      }

      // Remove required from all
      setRequiredFields(fixedAmountContainer, false);
      setRequiredFields(percentageAmountContainer, false);
      setRequiredFields(rangeContainer, false);
      setRequiredFields(lineItemContainer, false);
      setRequiredFields(perContainer, false);
    }
  }

  // Initialize current state
  toggleContainers();

  // Add event listener for price type changes
  priceTypeSelect.addEventListener('change', toggleContainers);

  // Add event listener for based_on changes (to update valuation symbols)
  if (basedOnSelect) {
    basedOnSelect.addEventListener('change', function() {
      updateValuationSymbols(basedOnSelect, priceCard);
    });

    // Update valuation symbols on initial load
    updateValuationSymbols(basedOnSelect, priceCard);
  }

  // Handle nested permit price ranges within this price card
  handlePermitPriceRanges(priceCard);

  // Handle line items container within this price card
  handlePermitPriceLineItems(priceCard);

  // Initialize Select2 for GL Code field (fallback for dynamically added cards)
  // The template JavaScript will handle initialization on turbolinks:load
  // This is a fallback for when cards are added dynamically
  setTimeout(function() {
    initializeGlCodeSelect(priceCard);
  }, 200);
}

function updateBasedOnOptions(basedOnSelect, isOptional) {
  const selectedBaseOnOption = basedOnSelect.value;
  const fixedOptions = isOptional ? [
    { value: '', text: 'None' },
    { value: 'valuation', text: 'Valuation', abbreviation: '$' },
    { value: 'square_footage', text: 'Square Footage', abbreviation: 'SF' },
    { value: 'inspection', text: 'Inspection' },
    { value: 'hour', text: 'Hour' },
    { value: 'week', text: 'Week' },
    { value: 'month', text: 'Month' },
    { value: 'session', text: 'Session' },
    { value: 'acre', text: 'Acre' },
    { value: 'lot', text: 'Lot' },
    { value: 'establishment', text: 'Establishment', abbreviation: 'EST' },
    { value: 'unit', text: 'Unit' },
    { value: 'trade', text: 'Trade' },
    { value: 'sales', text: 'Sales', abbreviation: 'VOL' },
    { value: 'cubic_yard', text: 'Cubic Yard', abbreviation: 'CY' },
    { value: 'head', text: 'Head', abbreviation: 'H' },
    { value: 'system', text: 'System', abbreviation: 'SYS' },
    { value: 'feet', text: 'Feet', abbreviation: 'FT' },
    { value: 'device', text: 'Device', abbreviation: 'D' },
    { value: 'flow_point', text: 'Flow Point', abbreviation: 'FP' },
    { value: 'floor', text: 'Floor', abbreviation: 'FL' },
    { value: 'gallon', text: 'Gallon', abbreviation: 'GAL' },
    { value: 'ton', text: 'Ton', abbreviation: 'TN' },
    { value: 'horse_power', text: 'Horsepower', abbreviation: 'HP' },
    { value: 'appliance', text: 'Appliance', abbreviation: 'APPL' },
    { value: 'outlet', text: 'Outlet', abbreviation: 'OUT' },
    { value: 'fixture', text: 'Fixture', abbreviation: 'FU' },
    { value: 'linear_feet_of_pipe', text: 'Linear Feet of Pipe', abbreviation: 'LFP' },
    { value: 'tow_truck', text: 'Tow Truck', abbreviation: 'TT' },
    { value: 'vehicle', text: 'Vehicle', abbreviation: 'VH' },
    { value: 'manufactured_home', text: 'Manufactured Home', abbreviation: 'MH' },
    { value: 'recreational_vehicle_space', text: 'Recreational Vehicle Space', abbreviation: 'RVS' },
    { value: 'per_lineal_feet', text: 'Per Lineal Feet', abbreviation: 'PLF' },
    { value: 'per_unit', text: 'Per', abbreviation: 'PER' },
    { value: 'per_bhp', text: 'Per BHP', abbreviation: 'BHP' },
    { value: 'per_incident', text: 'Per Incident', abbreviation: 'INCD' },
  ] : [
    { value: 'valuation', text: 'Valuation', abbreviation: '$' },
    { value: 'square_footage', text: 'Square Footage', abbreviation: 'SF' },
    { value: 'inspection', text: 'Inspection', abbreviation: 'INSP' },
    { value: 'hour', text: 'Hour', abbreviation: 'HR' },
    { value: 'week', text: 'Week', abbreviation: 'WK' },
    { value: 'month', text: 'Month', abbreviation: 'MO' },
    { value: 'session', text: 'Session', abbreviation: 'SES' },
    { value: 'acre', text: 'Acre', abbreviation: 'AC' },
    { value: 'lot', text: 'Lot', abbreviation: 'LT' },
    { value: 'establishment', text: 'Establishment', abbreviation: 'EST' },
    { value: 'unit', text: 'Unit', abbreviation: 'U/M' },
    { value: 'trade', text: 'Trade', abbreviation: 'TR' },
    { value: 'sales', text: 'Sales', abbreviation: 'VOL' },
    { value: 'cubic_yard', text: 'Cubic Yard', abbreviation: 'CY' },
    { value: 'head', text: 'Head', abbreviation: 'H' },
    { value: 'system', text: 'System', abbreviation: 'SYS' },
    { value: 'feet', text: 'Feet', abbreviation: 'FT' },
    { value: 'device', text: 'Device', abbreviation: 'D' },
    { value: 'flow_point', text: 'Flow Point', abbreviation: 'FP' },
    { value: 'floor', text: 'Floor', abbreviation: 'FL' },
    { value: 'gallon', text: 'Gallon', abbreviation: 'GAL' },
    { value: 'ton', text: 'Ton', abbreviation: 'TN' },
    { value: 'horse_power', text: 'Horsepower', abbreviation: 'HP' },
    { value: 'appliance', text: 'Appliance', abbreviation: 'APPL' },
    { value: 'outlet', text: 'Outlet', abbreviation: 'OUT' },
    { value: 'fixture', text: 'Fixture', abbreviation: 'FU' },
    { value: 'linear_feet_of_pipe', text: 'Linear Feet of Pipe', abbreviation: 'LFP' },
    { value: 'tow_truck', text: 'Tow Truck', abbreviation: 'TT' },
    { value: 'vehicle', text: 'Vehicle', abbreviation: 'VH' },
    { value: 'manufactured_home', text: 'Manufactured Home', abbreviation: 'MH' },
    { value: 'recreational_vehicle_space', text: 'Recreational Vehicle Space', abbreviation: 'RVS' },
    { value: 'per_lineal_feet', text: 'Per Lineal Feet', abbreviation: 'PLF' },
    { value: 'per_unit', text: 'Per', abbreviation: 'PER' },
    { value: 'per_bhp', text: 'Per BHP', abbreviation: 'BHP' },
    { value: 'per_incident', text: 'Per Incident', abbreviation: 'INCD' },
  ];

  basedOnSelect.options.length = 0;
  fixedOptions.forEach(option => {
    const newOption = document.createElement('option');
    newOption.value = option.value;
    newOption.textContent = option.text;
    newOption.selected = selectedBaseOnOption === option.value;
    if (option.abbreviation) {
      newOption.dataset.abbreviation = option.abbreviation;
    }
    basedOnSelect.appendChild(newOption);
  });
}

function updateValuationSymbols(basedOnSelect, priceCard) {
  const valuationSymbols = priceCard.querySelectorAll('.valuation-symbol');

  if (basedOnSelect && valuationSymbols.length > 0) {
    const selectedOption = basedOnSelect.options[basedOnSelect.selectedIndex];
    const symbol = selectedOption ? (selectedOption.dataset.abbreviation || '$') : '$';

    valuationSymbols.forEach(element => {
      element.textContent = symbol;
    });
  }
}

function addDefaultPriceRange(priceCard) {
  if (!priceCard) return;

  const feeContainer = priceCard.querySelector('.fee-container');
  if (!feeContainer) return;

  const existingRanges = feeContainer.querySelectorAll('.nested-fields');

  if (existingRanges.length === 0) {
    // Trigger the "Add More" button click to add a default range
    const addMoreButton = priceCard.querySelector('.btn.btn-outline-primary.w-25');
    if (addMoreButton) {
      addMoreButton.click();

      // Re-initialize after adding
      setTimeout(function() {
        handlePermitPriceRanges(priceCard);
      }, 100);
    }
  }
}

function addDefaultLineItem(priceCard) {
  if (!priceCard) return;

  const lineItemContainer = priceCard.querySelector('.line-item-container');
  if (!lineItemContainer) return;

  // Find the line items container
  let lineItemsContainer = lineItemContainer.querySelector('#permit-price-line-items');
  if (!lineItemsContainer) {
    lineItemsContainer = lineItemContainer.querySelector('[id^="permit-price-line-items"]');
  }
  if (!lineItemsContainer) {
    lineItemsContainer = lineItemContainer.querySelector('.d-grid.gap-3');
  }
  if (!lineItemsContainer) return;

  const existingLineItems = lineItemsContainer.querySelectorAll('.nested-fields');

  if (existingLineItems.length === 0) {
    // Find the "Add More Items" button within the line item container
    const linksContainer = lineItemContainer.querySelector('.links');
    if (linksContainer) {
      let addMoreItemsButton = linksContainer.querySelector('a[data-association="permit_price_line_items"]');
      if (!addMoreItemsButton) {
        // Fallback: look for link with text containing "Add More Items"
        const allLinks = linksContainer.querySelectorAll('a');
        allLinks.forEach(link => {
          if (link.textContent.trim().includes('Add More Items')) {
            addMoreItemsButton = link;
          }
        });
      }

      if (addMoreItemsButton) {
        addMoreItemsButton.click();

        // Re-initialize after adding
        setTimeout(function() {
          handlePermitPriceLineItems(priceCard);
        }, 100);
      }
    }
  }
}

function handlePermitPriceRanges(priceCard) {
  // Handle all nested price range type selectors within this price card
  // scoped to .range-container .fee-container only - the price card root is itself
  // a .nested-fields element, so an unscoped '.nested-fields select' query would
  // also match the fee-level price-type-select and wrongly treat it as a bracket row
  const nestedPriceTypeSelects = priceCard.querySelectorAll('.range-container .fee-container select[name*="[price_type]"]');

  // for fee type under range fees only - excludes the fee-level price-type select
  const bracketSelects = visibleBracketSelects(priceCard);
  const newSelects = [];

  nestedPriceTypeSelects.forEach(select => {
    // Check if this selector has already been handled
    if (!select.hasAttribute('data-price-type-handled')) {
      select.setAttribute('data-price-type-handled', 'true');
      if (bracketSelects.includes(select)) newSelects.push(select);
      select.addEventListener('change', function() {
        handlePriceRangeFields(this.closest('.nested-fields'));
        lockFeeTypeSelection(priceCard);
      });

      // Initialize on load
      handlePriceRangeFields(select.closest('.nested-fields'));
    }
  });

  // for a new row added via "Add More" (defaults to "Fixed")
  // its fee type should match with the rows that already exists
  newSelects.forEach(select => {
    const family = compatibleRangeFeeTypes(bracketSelects.filter(s => !newSelects.includes(s)));
    if (!family) return;
    select.value = family === 'per' ? 'per' : 'fixed';
    handlePriceRangeFields(select.closest('.nested-fields'));
  });

  // "Each" cannot be mixed with Fixed/Range within the same fee - disable the dropdown
  // options accordingly. runs on initialize and whenever a row is added, removed, or changed.
  lockFeeTypeSelection(priceCard);

  // Handle remove buttons - prevent removal of the first record
  updateRemoveButtonVisibility(priceCard);

  // Update valuation symbols
  const basedOnSelect = priceCard.querySelector('.based-on-select');
  if (basedOnSelect) {
    updateValuationSymbols(basedOnSelect, priceCard);
  }

  // Handle the "Add More" button for price ranges within this price card
  const addMoreButtons = priceCard.querySelectorAll('.add-more-ranges');
  addMoreButtons.forEach(addMoreButton => {
    if (addMoreButton && !addMoreButton.hasAttribute('data-listener-added')) {
      addMoreButton.setAttribute('data-listener-added', 'true');

      // Override cocoon's association_insertion_node to scope it to this price card
      const localFeeContainer = priceCard.querySelector('.range-container .fee-container');
      if (localFeeContainer && !localFeeContainer.id) {
        // Give it a unique ID for this price card
        const uniqueId = 'fee-container-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localFeeContainer.id = uniqueId;

        // Update the button to point to this specific ID
        addMoreButton.setAttribute('data-association-insertion-node', '#' + uniqueId);
      }

      // After cocoon adds the item, reinitialize
      addMoreButton.addEventListener('click', function(e) {
        setTimeout(function() {
          handlePermitPriceRanges(priceCard);
        }, 100);
      });
    }
  });

  // re-enable price-type options once a row is removed via Cocoon
  const feeContainer = priceCard.querySelector('.range-container .fee-container');
  if (feeContainer && !feeContainer.hasAttribute('data-remove-listener-added')) {
    feeContainer.setAttribute('data-remove-listener-added', 'true');
    $(feeContainer).on('cocoon:after-remove', function() {
      lockFeeTypeSelection(priceCard);
    });
  }
}

function handlePermitPriceLineItems(priceCard) {
  // Handle the "Add More Items" button for line items within this price card
  const lineItemContainer = priceCard.querySelector('.line-item-container');
  if (!lineItemContainer) return;

  // Find the line items container - it might have the default ID or a unique one
  let lineItemsContainer = lineItemContainer.querySelector('#permit-price-line-items');
  if (!lineItemsContainer) {
    // Try to find any div with id starting with permit-price-line-items
    lineItemsContainer = lineItemContainer.querySelector('[id^="permit-price-line-items"]');
  }
  if (!lineItemsContainer) {
    // Fallback: find the first .d-grid element in the line-item-container
    lineItemsContainer = lineItemContainer.querySelector('.d-grid.gap-3');
  }
  if (!lineItemsContainer) return;

  // Give the line items container a unique ID if it doesn't have one or if it's the default ID
  if (!lineItemsContainer.id || lineItemsContainer.id === 'permit-price-line-items') {
    const uniqueId = 'permit-price-line-items-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
    lineItemsContainer.id = uniqueId;
  }

  // Find the "Add More Items" button within this price card
  // Look for link that adds permit_price_line_items - cocoon adds data-association attribute
  const linksContainer = lineItemContainer.querySelector('.links');
  if (linksContainer) {
    // Try multiple selectors to find the button
    let addMoreItemsButton = linksContainer.querySelector('a[data-association="permit_price_line_items"]');
    if (!addMoreItemsButton) {
      // Fallback: look for link with text containing "Add More Items"
      const allLinks = linksContainer.querySelectorAll('a');
      allLinks.forEach(link => {
        if (link.textContent.trim().includes('Add More Items')) {
          addMoreItemsButton = link;
        }
      });
    }

    if (addMoreItemsButton && !addMoreItemsButton.hasAttribute('data-listener-added')) {
      addMoreItemsButton.setAttribute('data-listener-added', 'true');

      // Update the button to point to this specific line items container ID
      addMoreItemsButton.setAttribute('data-association-insertion-node', '#' + lineItemsContainer.id);
    }
  }
}

// all bracket-row price-type selects in this fee that are actually visible right now.
// a row cocoon has removed is only hidden, not removed from the DOM, so it has to be
// filtered out here or its leftover value would keep the remaining row(s) locked forever.
function visibleBracketSelects(priceCard) {
  const selects = priceCard.querySelectorAll('.range-container .fee-container select[name*="[price_type]"]');
  return Array.from(selects).filter(select => {
    const row = select.closest('.nested-fields');
    return row && row.style.display !== 'none';
  });
}

// "Each" is special range fee type is cumulative in nature and can't mix with Fixed/Range type
// this returns 'per' or 'non_per' if every given select agrees,
// otherwise null to keep range type selection free until one is selected to determine compatibility
function compatibleRangeFeeTypes(selects) {
  const values = selects.map(select => select.value);
  const hasPer = values.includes('per');
  const hasNonPer = values.some(value => value === 'fixed' || value === 'range');

  if (hasPer && !hasNonPer) return 'per';
  if (hasNonPer && !hasPer) return 'non_per';
  return null;
}

// disable the incompatible type option(s) in each range fee row's dropdown, based
// on what the sibling rows in the fee. A lone row has no sibling rows,
// so it stays unrestricted and can be set to any type, including "Each"
function lockFeeTypeSelection(priceCard) {
  const selects = visibleBracketSelects(priceCard);

  selects.forEach(select => {
    const family = compatibleRangeFeeTypes(selects.filter(s => s !== select));

    Array.from(select.options).forEach(option => {
      if (!option.value) return;
      if (family === 'per') {
        option.disabled = option.value !== 'per';
      } else if (family === 'non_per') {
        option.disabled = option.value === 'per';
      } else {
        option.disabled = false;
      }
    });

    const selected = select.options[select.selectedIndex];
    if (family && selected && selected.disabled) {
      select.value = family === 'per' ? 'per' : 'fixed';
      handlePriceRangeFields(select.closest('.nested-fields'));
    }
  });
}

function handlePriceRangeFields(rangeField) {
  const priceTypeSelect = rangeField.querySelector('select[name*="[price_type]"]');
  const fixedAmountField = rangeField.querySelector('.fixed-amount-field');
  const fixedAmountSuffix = rangeField.querySelector('.fixed-amount-suffix');
  const rangeFields = rangeField.querySelector('.range-fields');
  const isRequired = rangeField.closest('.permits-price-card').querySelector('.price-type-select').value == 'range';


  if (priceTypeSelect && fixedAmountField && rangeFields) {
    const selectedValue = priceTypeSelect.value;

    if (selectedValue === 'fixed' || selectedValue === 'per') {
      fixedAmountField.style.display = 'flex';
      rangeFields.style.display = 'none';
      if (fixedAmountSuffix) fixedAmountSuffix.textContent = selectedValue === 'per' ? '($) each' : '($)';

      setRequiredFields(fixedAmountField, isRequired);
      setRequiredFields(rangeFields, false);

    } else if (selectedValue === 'range') {
      fixedAmountField.style.display = 'none';
      rangeFields.style.display = 'block';

      setRequiredFields(fixedAmountField, false);
      setRequiredFields(rangeFields, isRequired);

    } else {
      fixedAmountField.style.display = 'none';
      rangeFields.style.display = 'none';

      setRequiredFields(fixedAmountField, false);
      setRequiredFields(rangeFields, false);
    }
  }
}

function updateRemoveButtonVisibility(priceCard) {
  const feeContainer = priceCard.querySelector('.fee-container');

  if (!feeContainer) return;

  const removeButtons = feeContainer.querySelectorAll('.fee.remove-icon');
  const nestedFields = feeContainer.querySelectorAll('.nested-fields');

  removeButtons.forEach((button, index) => {
    if (index === 0 && nestedFields.length === 1) {
      // Hide the first remove button when there's only one range
      button.style.display = 'none';
    } else {
      // Show all other remove buttons
      button.style.display = 'block';
    }
  });
}

function setRequiredFields(container, isRequired) {
  if (!container) return;

  const requiredControls = container.querySelectorAll('input[type="number"], select');

  requiredControls.forEach(control => {
    // Skip to_value fields - they should always be optional
    if (control.name && control.name.includes('[to_value]')) {
      control.classList.remove('requiredField');
      return;
    }

    try {
      if (isRequired) {
        control.classList.add('requiredField');
      } else {
        control.classList.remove('requiredField');
      }
    } catch (error) {
      console.warn('Error setting required field:', error);
    }
  });
}

function initializeGlCodeSelect(priceCard) {
  const glCodeSelect = priceCard.querySelector('.search-gl-code-permit-price');

  if (!glCodeSelect) return;

  var $glCodeSelect = $(glCodeSelect);

  // Check if Select2 is already initialized (by template JavaScript)
  if ($glCodeSelect.hasClass('select2-hidden-accessible')) {
    return;
  }

  // Get initial value and text from the option element
  const selectedOption = glCodeSelect.querySelector('option[selected]');
  const initialValue = selectedOption ? selectedOption.value : null;
  const initialText = selectedOption ? selectedOption.textContent : null;

  // Find the appropriate dropdown parent (modal or form-group)
  var dropdownParent = $glCodeSelect.closest('.modal');
  if (dropdownParent.length === 0) {
    dropdownParent = $glCodeSelect.closest('.form-group');
  }

  const searchUrl = glCodeSelect.dataset.searchUrl;

  var select2Config = {
    dropdownParent: dropdownParent,
    minimumInputLength: 0,
    placeholder: 'Select a GL Code',
    focus: true,
    allowClear: false,
    ajax: {
      url: searchUrl,
      dataType: 'json',
      delay: 250,
      data: function (params) {
        return {query: params.term}
      },
      processResults: function (data) {
        return {
          results: data
        };
      },
      cache: true
    },
    templateResult: formatGlCode,
    templateSelection: formatSelection
  };

  // Add initial data if there's a selected option
  if (initialValue && initialText) {
    select2Config.data = [{
      id: initialValue,
      gl_string: initialText
    }];
  }

  try {
    $glCodeSelect.select2(select2Config);

    // Set the initial value if it exists
    if (initialValue) {
      $glCodeSelect.val(initialValue).trigger('change');
    }
  } catch (error) {
    console.warn('Error initializing Select2 for GL code:', error);
  }
}

function formatGlCode(gl_code) {
  if (gl_code.loading) {
    return gl_code.text;
  }

  // Get jQuery reference
  var $ = window.$ || window.jQuery;

  // Use jQuery if available, otherwise create element manually
  if (typeof $ !== 'undefined') {
    return $(
      "<div class='select2-result-gl-code clearfix'>" +
      gl_code.gl_string +
      "</div>"
    );
  } else {
    var div = document.createElement('div');
    div.className = 'select2-result-gl-code clearfix';
    div.textContent = gl_code.gl_string;
    return div;
  }
}

function formatSelection(gl_code) {
  return gl_code.gl_string || gl_code.text;
}
